import { pathOr } from 'ramda';

import { PAGE_SUCCESS } from 'store/app/types';

import { types } from './actions';
import { MODES } from './constants';

const initialState = {
  accountId: null,
  billingAddress: null,
  billingAddressId: null,
  isLoading: false,
  isOpen: false,
  isSaving: false,
  mode: MODES.CREATE,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case PAGE_SUCCESS:
      return {
        ...initialState,
      };
    case types.CLOSE:
      return {
        ...initialState,
      };
    case types.SET_BILLING_ADDRESS:
      return {
        ...state,
        billingAddress: payload.billingAddress,
      };
    case types.OPEN_ERROR:
      return {
        ...state,
        isLoading: false,
        isOpen: false,
      };
    case types.OPEN_REQUEST:
      return {
        ...state,
        accountId: pathOr(null, ['accountId'], payload),
        billingAddressId: pathOr(null, ['billingAddressId'], payload),
        isLoading: true,
        isOpen: true,
        mode: payload.mode,
      };
    case types.OPEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.SAVE_SUCCESS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.common.drawers.billingAddressDrawer;

export const getAccountId = (state) => getScope(state).accountId;

export const getBillingAddress = (state) => getScope(state).billingAddress;

export const getBillingAddressId = (state) => getScope(state).billingAddressId;

export const getIsLoading = (state) => getScope(state).isLoading;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export const getMode = (state) => getScope(state).mode;
